export default {
  isEmpty (obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        return false
      }
    }

    return JSON.stringify(obj) === JSON.stringify({})
  },
  objectLength (obj) {
    var length = 0
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        ++length
      }
    }
    return length
  }
}



// WEBPACK FOOTER //
// ./src/helpers/functions.js